import React, { useEffect, useState } from "react";
import { Form, Input, Button, DatePicker } from "antd";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import Message from "../../Components/common/Message";
import "./pin.css";
import { useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { DatePickerField } from "../../Components/InputFields/InputFields";

const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  antInput: {
    "& .ant-form-item-control-input-content": {
      display: "flex",
      justifyContent: "center",
    },
    "& .ant-input-outlined": {
      width: "100%",
    },
    "& .ant-form-item .ant-form-item-explain-error": {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

const Pin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const date = new Date();
  const [routeDate, setRouteDate] = useState(date);
  const [pin, setPin] = useState('');
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const dateFormat = 'YYYY-MM-DD';


  // const onFinish = async ({pin, DatePicker}) => {
  //   console.log('DatePicker', DatePicker)
  //   const expirationDate = moment().add(1, "days").format("YYYY-MM-DD");
  //   const dataToSend = {
  //     pin: pin,
  //     // delivery_date: "2024-02-23",
  //     delivery_date: moment(new Date(DatePicker)).format('YYYY-MM-DD'),
  //   };
  //   setLoadMessage("");
  //   setIsLoading(true);
  //   try {
  //     const response = await Auth.fetch(`/driverapp/pin`, {
  //       method: "POST",
  //       body: JSON.stringify(dataToSend),
  //     });
  //     if (response?.ack) {
  //       localStorage.setItem("securityPin", pin);
  //       localStorage.setItem("pinExpiration", expirationDate);
  //       localStorage.setItem(
  //         "driverRoutes",
  //         JSON.stringify(response.driver_routes)
  //       );
  //       localStorage.setItem(
  //         "DriverName",
  //         response.driver_routes[0]?.driver_name
  //       );
  //       dispatch({ type: "SET_ROUTES", payload: response.driver_routes });
  //       navigate("/dashboard");
  //       setIsLoading(false);
  //     } else {
  //       setType("error");
  //       setLoadMessage(response.message);
  //       setIsLoading(false);
  //     }
  //   } catch (err) {
  //     setType("error");
  //     setLoadMessage(err.message);
  //     setIsLoading(false);
  //   }
  // };

  const onFinish = () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    if(!pin) {
      setType('error')
      setLoadMessage(`Enter Pin to continue ${str}`)
      return;
    }
    if(!routeDate) {
      setType('error')
      setLoadMessage(`Enter date to continue ${str}`)
      return;
    }
    const expirationDate = moment().add(1, "days").format("YYYY-MM-DD");
        localStorage.setItem("securityPin", pin);
        localStorage.setItem("pinExpiration", expirationDate);
        const Delivery = moment(new Date(routeDate)).format('YYYY-MM-DD');
        localStorage.setItem("delivery_date", Delivery);

        navigate("/dashboard");
  }

  useEffect(()=>{
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    // navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  },[])
  return (
    <>
      <div className="box">
        <h2 className="box-heading">Use your login Pin to continue</h2>
        
          <Input size="large" value={pin} onChange={(e)=> setPin(e.target.value)} placeholder="Enter Your Pin" />
          
        <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: '10px',
                  marginTop: '10px',
                  justifyContent: "center",
                }}
              >
                <span style={{ marginRight: '8px'}}> Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:</span>
                <DatePickerField
                 todayButton="Today"
                 dateFormat="dd-MM-yyyy"
                  selected={routeDate}
                  onChange={(date) => {
                    setRouteDate(date);
                  }}
                />
              </div>
              <div style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: '10px',
                  marginTop: '10px',
                  justifyContent: "center",
                }}>
              <Button
              style={{
                height: "40px",
                width: "100px",
                padding: "4px",
                fontSize: "15px",
              }}
              size="large"
              type="primary"
              htmlType="submit"
              loading={isLoading}
              onClick={onFinish}
            >
              Submit
            </Button>
              </div>
              
      </div>
      <Message type={type} msg={loadMessage} />
    </>
  );
};

export default Pin;
